{
  "$id": "wealthlane://forms/role-mapping/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "role_mapping_header",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/destinationRoleId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480
        }
      ]
    }
  ]
}
